import { defineComponent as _defineComponent } from 'vue'
import { HouseDesignInterface } from "@/types/HouseDesignInterface";
  import { ref, computed } from "vue";
  import { formatPrice as formatMeters } from "@/helpers/transformation/price";
  import { useIsDesktop } from "@/features/useIsDesktop";

  interface Props {
    houseDesign: HouseDesignInterface;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderFloorplansFeaturesModal',
  props: {
    houseDesign: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const fadeInEffectSlider = ref(false);
  const { isDesktop } = useIsDesktop(990);

  const onButtonClickSlider = () => {
    fadeInEffectSlider.value = !fadeInEffectSlider.value;
  };

  const selectedHouseDesign = computed(() => props.houseDesign);

  const props = __props;

const __returned__ = { fadeInEffectSlider, isDesktop, onButtonClickSlider, selectedHouseDesign, props, get HouseDesignInterface() { return HouseDesignInterface }, ref, computed, get formatMeters() { return formatMeters }, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})